module.exports = __webpack_public_path__ + "media/images/computer-p-500-872cac1314ec539fc6fb383a08062b24.jpeg";